export { default } from './PhoneInput'

export const defaultPhone = "+ 375 (__) ___ __ __"